import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, PAGE_SIZE } from '../common';
import { IBiomarker, IBiomarkerFilter, IUnit } from './models';

export const biomarkersApiSlice = createApi({
  reducerPath: 'biomarkers/api',
  baseQuery: axiosBaseQuery({
    baseUrl: 'biomarkers/',
  }),
  endpoints: builder => ({
    getBiomarkers: builder.query<IState<IBiomarker>, IBiomarkerFilter>({
      query: data => ({
        url: `fn/search`,
        method: 'POST',
        data,
      }),
      transformResponse: (response: IAxiosResponse<IBiomarker[]>): IState<IBiomarker> => ({
        data: response.data,
        isEnd: response.data.length < PAGE_SIZE,
      }),
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      merge(currentCacheData, responseData, otherArgs) {
        if (otherArgs.arg.pageNumber > 0) {
          responseData.data.unshift(...currentCacheData.data);
          return responseData;
        }
        return responseData;
      },
    }),
    getUnitsByBiomarkerId: builder.query<IUnit[], string>({
      query: biomarkerId => ({
        url: `${biomarkerId}/units`,
        method: 'GET',
      }),
      transformResponse: (response: IAxiosResponse<IUnit[]>) => response.data,
    }),
  }),
});
